import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["error", "readOnly", "disabled", "errorInPopover", "warning", "warningInPopover", "label", "popoverContent", "errorClass", "warningClass", "mouseEnterDelay"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';
import _isFunction from 'lodash/isFunction';
import Label from '../../atoms/Label';
import Popover from '../popover/TPopover';
import Info from '../Info';
import PopoverContent from './PopoverContent';
import styles from './input.module.scss';
import 'tstyles/component.scss';

// Component
import InputWrapper from '../inputWrapper';
var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);
  var _super = _createSuper(Input);
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getInput", function () {
      var _this$props = _this.props,
        error = _this$props.error,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        errorInPopover = _this$props.errorInPopover,
        warning = _this$props.warning,
        warningInPopover = _this$props.warningInPopover,
        label = _this$props.label,
        popoverContent = _this$props.popoverContent,
        errorClass = _this$props.errorClass,
        warningClass = _this$props.warningClass,
        mouseEnterDelay = _this$props.mouseEnterDelay,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var popoverMessage = error || warning;
      var messageType = error && 'error' || warning && 'warning';
      var asPopover = errorInPopover || warningInPopover;
      var id = "".concat((label || '').split(' ').join(''), "Error");
      if (asPopover || popoverContent) {
        return /*#__PURE__*/React.createElement(Popover, {
          placement: "top",
          content: popoverContent || /*#__PURE__*/React.createElement(PopoverContent, {
            message: popoverMessage,
            messageType: messageType
          }),
          trigger: "hover",
          mouseEnterDelay: mouseEnterDelay
        }, /*#__PURE__*/React.createElement(InputWrapper, _extends({}, rest, {
          hasError: !!error,
          hasWarning: !!warning,
          readOnly: readOnly,
          disabled: disabled
        })), error && !errorInPopover && /*#__PURE__*/React.createElement("span", {
          className: classNames(styles.error, errorClass)
        }, error));
      }
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(InputWrapper, _extends({}, rest, {
        hasError: !!error,
        hasWarning: !!warning,
        readOnly: readOnly,
        disabled: disabled
      })), error && _this.renderInputError(id), warning && !error && /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.error, styles.warning, warningClass),
        id: id
      }, warning));
    });
    return _this;
  }
  _createClass(Input, [{
    key: "renderInputError",
    value: function renderInputError(id) {
      var _this$props2 = this.props,
        error = _this$props2.error,
        errorClass = _this$props2.errorClass,
        renderError = _this$props2.renderError;
      if (_isFunction(renderError)) return renderError({
        error: error
      });
      return /*#__PURE__*/React.createElement("span", {
        className: classNames(styles.error, errorClass),
        id: id
      }, error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        label = _this$props3.label,
        required = _this$props3.required,
        containerClassName = _this$props3.containerClassName,
        wrapperDivProps = _this$props3.wrapperDivProps,
        labelClassName = _this$props3.labelClassName,
        helpTextClassName = _this$props3.helpTextClassName,
        helpText = _this$props3.helpText,
        infoPlacement = _this$props3.infoPlacement,
        infoClassName = _this$props3.infoClassName;
      return /*#__PURE__*/React.createElement("div", _extends({
        className: "".concat(styles.inputContainer, " ").concat(containerClassName)
      }, wrapperDivProps), (label || helpText) && /*#__PURE__*/React.createElement("div", {
        className: "flex"
      }, label && /*#__PURE__*/React.createElement(Label, {
        required: required,
        className: "".concat(styles.label, " ").concat(labelClassName)
      }, label), helpText && /*#__PURE__*/React.createElement(Info, {
        placement: infoPlacement,
        helpText: helpText,
        tooltipClass: helpTextClassName,
        className: infoClassName
      })), this.getInput());
    }
  }]);
  return Input;
}(React.Component);
_defineProperty(Input, "propTypes", {
  containerClassName: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  renderError: PropTypes.func,
  error: PropTypes.string,
  errorInPopover: PropTypes.bool,
  errorClass: PropTypes.string,
  warning: PropTypes.string,
  warningInPopover: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  helpText: PropTypes.string,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  labelClassName: PropTypes.string,
  helpTextClassName: PropTypes.string,
  infoPlacement: PropTypes.string,
  popoverContent: PropTypes.node,
  wrapperDivProps: PropTypes.object,
  warningClass: PropTypes.string,
  mouseEnterDelay: PropTypes.number,
  infoClassName: PropTypes.string
});
_defineProperty(Input, "defaultProps", {
  containerClassName: '',
  placeholder: __('Type Here'),
  onFocus: _noop,
  onBlur: _noop,
  renderError: undefined,
  error: '',
  errorInPopover: false,
  errorClass: '',
  warning: '',
  warningInPopover: false,
  label: '',
  helpText: '',
  readOnly: false,
  disabled: false,
  required: false,
  labelClassName: '',
  helpTextClassName: '',
  infoPlacement: undefined,
  popoverContent: null,
  wrapperDivProps: null,
  warningClass: '',
  mouseEnterDelay: 0,
  infoClassName: undefined
});
export default Input;